module.exports = __webpack_public_path__ + "static/img/pic24.ea0349a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic24.png
// module id = oMVs
// module chunks = 0